var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _setup.visible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": "whatsapp-balance-insufficient-dialog",
      "width": "400px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _setup.visible = $event;
      }
    }
  }, [_c('section', {
    staticClass: "whatsapp-balance-insufficient-dialog__content"
  }, [_c('button', {
    staticClass: "whatsapp-balance-insufficient-dialog__close",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('common.Close')
    },
    on: {
      "click": _setup.closeDialog
    }
  }, [_c('img', {
    attrs: {
      "src": _setup.closeIcon,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "whatsapp-balance-insufficient-dialog__illustration",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('img', {
    staticClass: "whatsapp-balance-insufficient-dialog__illustration-main",
    attrs: {
      "src": _setup.insufficientIllustration,
      "alt": ""
    }
  }), _c('img', {
    staticClass: "whatsapp-balance-insufficient-dialog__illustration-spark",
    attrs: {
      "src": _setup.insufficientSpark,
      "alt": ""
    }
  })]), _c('h2', [_vm._v(_vm._s(_vm.$t('dashboard.WhatsApp-Balance-Insufficient-Title')))]), _c('p', {
    staticClass: "whatsapp-balance-insufficient-dialog__description"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.WhatsApp-Balance-Insufficient-Content')))]), _c('dl', {
    staticClass: "whatsapp-balance-insufficient-dialog__summary"
  }, [_c('div', [_c('dt', [_vm._v(_vm._s(_vm.$t('marketing.CurrentBalance')))]), _c('dd', {
    staticClass: "whatsapp-balance-insufficient-dialog__amount--danger"
  }, [_vm._v(_vm._s(_setup.balance))])]), _c('div', [_c('dt', [_vm._v(_vm._s(_vm.$t('dashboard.WhatsApp-Estimated-Send-Cost')))]), _c('dd', [_vm._v(_vm._s(_setup.estimatedCost))])])]), _c('button', {
    staticClass: "whatsapp-balance-insufficient-dialog__recharge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _setup.goToRecharge
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.Go-Recharge')) + " ")])])]), _setup.rechargeDialogVisible ? _c(_setup.RechargeDialog, {
    attrs: {
      "visible": _setup.rechargeDialogVisible,
      "balance": _setup.rechargeBalance
    },
    on: {
      "update:visible": function ($event) {
        _setup.rechargeDialogVisible = $event;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };